function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    id: "svg4",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "24 / notifications / alert-circle",
    style: {
      opacity: 0.5
    },
    transform: "translate(-1,-1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M 1,12 C 1,18.0751 5.92487,23 12,23 18.0751,23 23,18.0751 23,12 23,5.92487 18.0751,1 12,1 5.92487,1 1,5.92487 1,12 Z m 20,0 c 0,4.9706 -4.0294,9 -9,9 -4.97056,0 -9,-4.0294 -9,-9 0,-4.97056 4.02944,-9 9,-9 4.9706,0 9,4.02944 9,9 z m -8.9997,5.9983 c 0.5525,0 1.0004,-0.4477 1.0004,-1 0,-0.5522 -0.4479,-1 -1.0004,-1 -0.5524,0 -1.0003,0.4478 -1.0003,1 0,0.5523 0.4479,1 1.0003,1 z M 13.0036,5.99835 H 11.003 v 7.99995 h 2.0006 z",
    style: {
      clipRule: "evenodd",
      fill: "#000000",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.b473ae0a7a78d2c9678a86e7c6631abe.svg";
export { ForwardRef as ReactComponent };